export default __webpack_public_path__ + "static/galleries_321-a22a57fa95d6a7e8bace3248c4dbc9cf.jpg";